import { render, staticRenderFns } from "./accountManagement.vue?vue&type=template&id=0ab5d988&scoped=true"
import script from "./accountManagement.vue?vue&type=script&lang=js"
export * from "./accountManagement.vue?vue&type=script&lang=js"
import style0 from "./accountManagement.vue?vue&type=style&index=0&id=0ab5d988&prod&lang=css"
import style1 from "./accountManagement.vue?vue&type=style&index=1&id=0ab5d988&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab5d988",
  null
  
)

export default component.exports